<template>
  <div style="background-color: white" ref="mainarea">
    <div v-if="(projectId && projectId > 0) ||
      (this.$route.query.projectId && this.$route.query.projectId.length > 0) ||
      (this.$route.query.eid && this.$route.query.eid.length > 0)
      ">
      <div>
        <ProjectEmbedPane ref="projectEmbedPane" :ProjectId="this.projectId" :DetailsItem="currentEmbed"
          @SelectionChanged="selectedEmbedChanged" :IsEdit="IsAddEditEmbed"
          :AllowEmbedNotifications="AllowEmbedNotifications" :EmailsToNotify="EmailsToNotifyOnEmbed"
          @EmbedOpened="EmbedOpened($event)" @EmbedUpdatedOrCreated="EmbedCrudDone" @EmbedCrudError="EmbedCrudError"
          @EmbedEditExit="EmbedEditExit" :Mode="Mode" @ModeChanged="ModeChanged" :TriggerUrl="TriggerUrl" style=""></ProjectEmbedPane>
      </div>
    </div>
    <div v-else>
      <div v-if="Projects != null && Projects.length > 0">
        <div class="vx-row" style="margin-bottom: 50px">
          <div class="vx-col sm:w-1/1 md:w-2/3 lg:w-2/3 xl:w-2/3 mb-base">
            <h1 style="
                color: black;
                font-weight: 100;
                font-size: 40px;
                padding-bottom: 20px;
              ">
              <strong data-v-79536e0c="">360&deg;</strong> overview
            </h1>
            <br />
            <input type="text" class="main-search-txt" v-model="filterString"
              placeholder="Filter projects" /><br /><br />
            <div class="vx-row">
              <div class="vx-col w-full md:w-2/3 lg:w-1/2 xl:w-1/2 mb-base">
                <vx-card v-if="!loading" style="
                  background: linear-gradient(118deg, rgb(255 255 255), rgb(255 255 255 / 70%)) 0% 0% / cover no-repeat;
    color: var(--success);
    cursor: pointer;
    min-height: 150px;
    border: 1px solid var(--primary);" :title="''" title-color="#000" content-color="#000" @CardClick="AddProject">
                  <p
                    style="text-align: center; vertical-align: center; color: var(--primary) !important; font-size:70px;">
                    +
                  </p>
                </vx-card>
              </div>
              <div v-for="(project) in FilteredProjects" :key="project.Id"
                class="vx-col w-full md:w-2/3 lg:w-1/2 xl:w-1/2 mb-base">
                <vx-card v-if="!loading"
                  style="
                  cursor: pointer; background-size: cover; background-repeat: no-repeat; color:white;
                  background: linear-gradient(118deg, var(--primary), rgb(20 20 20 / 70%)), var(--bg-img-1); min-height:150px;"
                  :title="project.Title" title-color="#000" content-color="#000" @CardClick="selectedProject = project">
                  <p>
                    {{ project.ShortSummary ? project.ShortSummary : 'This project has no summary yet.' }}
                  </p>
                </vx-card>
              </div>
            </div>
          </div>
          <div class="vx-col sm:w-1/1 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base" v-if="overviewStats != null">
            <h1 style="
                color: black;
                font-weight: 100;
                font-size: 40px;
                padding-bottom: 20px;
              ">
              Quick <strong>Stats</strong>
            </h1>

            <div class="mb-5" v-if="overviewStats && overviewStats.History && overviewStats.History.length > 0">
              <div class="mt-5">
                <vx-card style="
                  cursor: pointer;" :title="'History:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in overviewStats.History" class="mb-1 vx-col pt-3 mb-5"
                      style="width:100%;">
                      <div style="float:left; margin-right:20px;">
                        <UserAvatar v-if="item.CreatedBy" :userProfile="item.CreatedBy" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar>
                        <div style="clear:both;"></div>
                        <div style="font-size:0.7em;">
                          {{ moment(item.Assignment.LastUpdatedOn) }}
                        </div>
                      </div>
                      <div>
                        <strong><a :href="'/pages/context-and-onboarding?eid=' + item.EmbedData.Id">{{
      item.EmbedData.Title }}</a></strong><br /><a
                          :href="'/pages/context-and-onboarding?projectId=' + item.ProjectId">{{ item.ProjectTitle
                          }}</a><br />


                        <div v-if="item.Assignment.Comment"
                          style="padding-left: 70px; padding-top:10px; font-size:0.8em; font-style: italic;">
                          {{ item.Assignment.Comment }}
                        </div>

                        <div
                          v-if="item.WorkflowInfo && item.WorkflowInfo.WorkflowStep && item.WorkflowInfo.WorkflowStep.IconBase64"
                          style="position: absolute; right: 30px; background: #efefef; border-radius: 50%; padding: 5px;">
                          <img v-if="item.WorkflowInfo.WorkflowStep.IconBase64"
                            :src="item.WorkflowInfo.WorkflowStep.IconBase64">
                        </div>
                        <div
                          v-if="item.WorkflowInfo && item.WorkflowInfo.WorkflowStep && !item.WorkflowInfo.WorkflowStep.IconBase64"
                          style="position: absolute; right: 30px; background: #efefef; padding: 10px;">
                          <span>
                            {{ item.WorkflowInfo.WorkflowStep.Title }}
                          </span>
                        </div>

                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>

            <div class="mb-5">
              <div class="" v-if="ownerStats">
                <vx-card v-if="!loading" style="
                  cursor: pointer;" :title="'Owner:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in ownerStats" class="mb-5 vx-col">
                      <div style="float:left;">
                        <UserAvatar v-if="item.Key" :userProfile="item.Key" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar> x {{ item.Count }}
                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="mb-5">
              <div class="mt-5" v-if="correctAssesment">
                <vx-card v-if="!loading && correctAssesment > 0" style="
                  cursor: pointer;" :title="'Assessed:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in correctAssesment" class="mb-5 vx-col">
                      <div style="float:left;">
                        <UserAvatar v-if="item.Key" :userProfile="item.Key" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar> x {{ item.Count }}
                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="mb-5">
              <div class="mt-5" v-if="overEmail">
                <vx-card v-if="!loading" style="
                  cursor: pointer;" :title="'Checked in over email:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in overEmail" class="mb-5 vx-col">
                      <div style="float:left;">
                        <UserAvatar v-if="item.Key" :userProfile="item.Key" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar> x {{ item.Count }}
                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="mb-5">
              <div class="mt-5" v-if="blockingAssessments && blockingAssessments.length > 0">
                <vx-card v-if="!loading" style="
                  cursor: pointer;" :title="'Checked in over email:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in blockingAssessments" class="mb-5 vx-col">
                      <div style="float:left;">
                        <UserAvatar v-if="item.Key" :userProfile="item.Key" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar> x {{ item.Count }}
                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="mb-5">
              <div class="mt-5" v-if="readStats">
                <vx-card v-if="!loading" style="
                  cursor: pointer;" :title="'Read:'" title-color="#000" content-color="#000">
                  <div class="vx-row">
                    <div v-for="(item, itemIdx) in readStats" class="mb-5 vx-col">
                      <div style="float:left;">
                        <UserAvatar v-if="item.Key" :userProfile="item.Key" size="32px" color="primary"
                          class="user-profile-main" style="float:left;"></UserAvatar> x {{ item.Count }}
                      </div>
                      <br />
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Projects != null && Projects.length == 0 && !loading">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 md:w-2/3 lg:w-2/3 xl:w-2/3 mb-base">
            <h1>
              No projects
            </h1><br />
            <a style="cursor:pointer;" @click="AddProject">
              Create your first project
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false">
      Please select a project first:<br />
      <v-select label="Title" value="Id" :closeOnSelect="true" :options="Projects" v-model="selectedProject"
        :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br />
    </div>
    <vs-popup title="Add Project" :active.sync="isInGitClone">
      <GitClone :ProjectOnly="'true'" :PopupTitle="'Add Project'"></GitClone>
    </vs-popup>
  </div>
</div></template>
<script>
import ProjectEmbedPane from "@/views/components/organisms/embeds/ProjectEmbedPane.vue";
import ProjectsService from "@/projects/projectsService.js";
import vSelect from "vue-select";
import apexChatData from '@/views/charts-and-maps/charts/apex-charts/apexChartData.js'
import VueApexCharts from 'vue-apexcharts';
import embedService from "@/embeds/embedService.js";
import UserAvatar from "@/views/components/extra-components/users/UserAvatar.vue";
import GitClone from "@/views/components/organisms/gitorganisms/GitClone.vue";
import moment from "vue-moment";
import accountsService from "../../accounts/accountsService";

export default {
  created() {
    var instance = this;
    window.onhashchange = function () {
      instance.EmbedEdit();
    };
  },
  destroyed() { },
  mounted() {
    if (this.$route.query && this.$route.query.triggerurl){
      this.$set(this, "TriggerUrl", this.$route.query.triggerurl);
    }

    if (!this.$route.query || (!this.$route.query.projectId && !this.$route.query.eid)) {
      this.GetProjects();
      this.GetStatsForAllProjectsInAccount();

    }
    else if (!this.$route.query.eid || !(this.$route.query.eid.length > 0)) {
      var instance = this;
      ProjectsService.getProject(this.$route.query.projectId).then(function (response) {
        instance.$set(instance, "selectedProject", response.data);
        instance.$set(instance, "loading", false);
      });
    }
  },
  data() {
    return {
      selectedProject: null,
      projectId: null,
      currentEmbed: null,
      SelectedEmbed: null,
      IsAddEditEmbed: false,
      AllowEmbedNotifications: true,
      AllowNotifyChecked: false,
      GeneratedDescription: "",
      GeneratedTitle: "",
      Projects: [],
      Mode: "",
      filterString: null,
      loading: true,
      apexChatData: apexChatData,
      chatStart: '',
      overviewStats: null,
      readStats: null,
      ownerStats: null,
      correctAssesment: null,
      incorrectAssessment: null,
      overEmail: null,
      blockingAssessments: null,
      isInGitClone: false,
      TriggerUrl: null
    };
  },
  methods: {
    ProjectSelected(project) {
      alert(project);
    },
    moment(dateString) {
      const moment = require("moment");
      return moment(dateString).fromNow();
    },
    AddProject() {
      this.$set(this, "isInGitClone", true);
    },
    GetStatsForAllProjectsInAccount() {
      var instance = this;
      return embedService.GetStatsForAllProjectsInAccount().then(function (response) {

        var read = "Read";
        var ownership = "Owner";
        var correctlyAssessed = "Correct Assessment";
        var overEmail = "Onboarded over email";
        var incorrectAssessment = "Incorrect Assessment";
        var blocking = "Blocking"

        instance.$set(instance, "overviewStats", response.data);

        instance.$set(instance, "readStats", instance.getGroupByType(read));
        instance.$set(instance, "ownerStats", instance.getGroupByType(ownership));
        instance.$set(instance, "correctAssesment", instance.getGroupByType(correctlyAssessed));
        instance.$set(instance, "overEmail", instance.getGroupByType(overEmail));
        instance.$set(instance, "incorrectAssessment", instance.getGroupByType(incorrectAssessment));
        instance.$set(instance, "blockingAssessments", instance.getGroupByType(blocking));
      });
    },
    getGroupByType(type) {
      var items = this.overviewStats.UserGroups;
      if (items && items.length > 0) {
        var group = items.filter(itm => itm.Group === type);
        if (group && group.length > 0) {
          return group[0].Users;
        }
      }

      return [];
    },
    selectedEmbedChanged(node) {
      this.$set(this, "SelectedEmbed", node);
    },
    EmbedCrudDone(eventData) {
      this.$set(this, "currentEmbed", eventData.embed);
      this.$set(this, "IsAddEditEmbed", false);
      this.$set(this, "GeneratedDescription", "");
      this.$set(this, "GeneratedTitle", "");
    },
    EmbedEditExit(hasExited) {
      if (hasExited) {
        this.$set(this, "currentEmbed", null);
        this.$set(this, "IsAddEditEmbed", false);
        this.$set(this, "GeneratedDescription", "");
      }
    },
    EmbedCrudError(error) {
      this.$vs.notify({
        time: 8000,
        title: "Error",
        text: error.error,
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
      });
    },
    EmbedOpened(evt) {
      if (window.chrome && window.chrome.webview && window.chrome.webview.postMessage) {
        window.chrome.webview.postMessage({
          op: "OPEN_EMBED",
          arg: evt,
        });
      }

      this.$router.push("?eid=" + evt.Id);
    },
    EmbedSet(evt) {
      var instance = this;
      instance.$set(instance, "IsAddEditEmbed", false);

      if (evt && evt.detail && evt.detail.length > 0) {
        try {
          var embed = JSON.parse(evt.detail);
          if (instance.SelectedEmbed && instance.SelectedEmbed.data.EmbedFullArea) {
            embed.EmbedArea = instance.SelectedEmbed.data.EmbedFullArea;
          }

          if (embed.projectId) instance.$set(instance, "projectId", embed.ProjectId);

          instance.$refs.projectEmbedPane.LoadEmbeds();

          instance.$nextTick(function () {
            instance.$set(instance, "currentEmbed", embed);
            instance.$set(instance, "IsAddEditEmbed", true);
          });
        } catch (err) {
          alert("Error opening embed selection.");
          throw err;
        }
      }
    },
    EmbedEdit() {
      var instance = this;
      var embed = null;

      if (window.location.hash && window.location.hash.length > 0) {
        try {
          var original = window.location.hash.substr(1);
          var embedAsString = atob(original);

          embed = JSON.parse(embedAsString);

          instance.$set(instance, "currentEmbed", embed);
          instance.$set(instance, "IsAddEditEmbed", true);
        } catch (err) { }
      }
    },
    GetProjects() {
      var instance = this;
      var userInfoFull = accountsService.getUserFromLocalStorage();
      var user = userInfoFull.User;
      var filters =
        'Item.Title.Contains("") || item.ProjectName.Contains("") || Item.Slug.Contains("")';

      instance.$vs.loading({
        container: instance.$refs.mainarea,
        scale: 1,
      });

      ProjectsService.getProjects(user.Id, filters, 0, 1000, true).then(function (
        response
      ) {
        var mapped = response.data.Items.map(function (item) {
          return {
            Title: item.Title,
            Id: item.Id,
            ShortSummary: item.ShortSummary
          };
        });

        instance.$set(instance, "Projects", mapped);
        instance.$set(instance, "loading", false);
        instance.$vs.loading.close(instance.$refs.mainarea);
      });
    },
    ModeChanged(newMode) {
      this.$set(this, "Mode", newMode);
    },
  },
  components: {
    ProjectEmbedPane,
    vSelect,
    VueApexCharts,
    UserAvatar,
    GitClone
  },
  watch: {
    selectedProject: function (newval) {
      this.$set(this, "projectId", newval.Id.toString());
      if (!this.$route.query.projectId || this.$route.query.projectId != this.projectId) {
        this.$router.push("?projectId=" + newval.Id);
      }
    },
  },
  props: ["EmailsToNotifyOnEmbed"],
  computed: {
    FilteredProjects: function () {
      if (this.Projects) {
        if (this.filterString) {
          var result = [
            ...this.Projects.filter(
              (p) => p.Title.toLowerCase().indexOf(this.filterString.toLowerCase()) > -1
            ),
          ];
          return result;
        }
        return this.Projects;
      }
    },
  },
};
</script>
<style>
body {
  background: white;
}

.main-search-txt {
  font-size: 1.2em;
  width: 100%;
  padding: 0.1em 0.5em;
  height: 4em;
  border: 1px solid rgb(209, 209, 209);
}
</style>

<style scoped>
*>>>.vx-card h4 {
  font-weight: 900 !important;
  color: var(--light-text) !important;
}

*>>>.vx-card p {
  color: var(--light-text) !important;
}
</style>
